import React, { FC, useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useLazyQuery } from '@apollo/client';
import { getTerritoryPinnedArticles } from './queries/getTerritoryPinnedArticles';
import { useUserTerritoryPermissions } from '../Territory/services/useUserTerritoryPermissions';
import { getArticlesCardData } from '../ArticleCard/services/getArticlesCardData';
import { TerritoryExploreContent } from './TerritoryExploreContent';

type TTerritoryPostsPinnedByAdminContainerProps = {
  territoryId: string;
  isPinningEnabled: boolean;
  canManagePinnedArticles: boolean;
  hideSortingDropdown: boolean;
  isAuthLoading?: boolean;
  hideSeeAllButton?: boolean;
};

export const TerritoryExplorePostsPinnedByAdminSection: FC<TTerritoryPostsPinnedByAdminContainerProps> = ({
  territoryId,
  isPinningEnabled,
  canManagePinnedArticles,
  hideSortingDropdown,
  isAuthLoading,
  hideSeeAllButton = false,
}) => {
  const { isTerritoryMember } = useUserTerritoryPermissions({ territoryId });

  const [getTerritoryPinnedArticlesData, { data, loading: isLoading }] = useLazyQuery(getTerritoryPinnedArticles, {
    variables: {
      territoryId,
    },
  });

  const { articles = [] } = data || {};
  const mappedArticles = getArticlesCardData(articles, isTerritoryMember);

  useEffect(() => {
    getTerritoryPinnedArticlesData();
  }, []);

  if (isEmpty(mappedArticles)) {
    return null;
  }

  return (
    <div className="mb-12">
      <TerritoryExploreContent
        territoryId={territoryId}
        sectionTitle="Pinned by Admin"
        articles={mappedArticles}
        canManagePinnedArticles={canManagePinnedArticles}
        isPinningEnabled={isPinningEnabled}
        forceMobileView
        gridColumns="two"
        hideSortingDropdown={hideSortingDropdown}
        isLoading={isLoading}
        isAuthLoading={isAuthLoading}
        hideSeeAllButton={hideSeeAllButton}
      />
    </div>
  );
};
